import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export function InvalidImage(props: SvgIconProps) {
    return (
        <SvgIcon {...props}>
            <path d="M21.9,21.9l-8.49-8.49l0,0L3.59,3.59l0,0L2.1,2.1L0.69,3.51L3,5.83V19c0,1.1,0.9,2,2,2h13.17l2.31,2.31L21.9,21.9z M5,18 l3.5-4.5l2.5,3.01L12.17,15l3,3H5z M21,18.17L5.83,3H19c1.1,0,2,0.9,2,2V18.17z" />
        </SvgIcon>
    );
}
